import React from "react";
import Select from "react-select";
import "./MultiSelectDropdown.css";

function MultiSelectDropdown({
  options = [],
  value = [],
  onChange,
  placeholder = "Select...",
  disabled = false,
  searchable = true,
  className = "",
}) {
  const safeOptions = Array.isArray(options) ? options : [];
  const normalizedValue = Array.isArray(value)
    ? value
        .map((item) => (typeof item === "number" ? item : parseInt(item, 10)))
        .filter((item) => !isNaN(item))
    : [];

  const selectedOptions = safeOptions.filter((option) => {
    if (!option || typeof option !== "object") return false;
    const optionValue =
      typeof option.value === "number"
        ? option.value
        : parseInt(option.value, 10);
    return !isNaN(optionValue) && normalizedValue.includes(optionValue);
  });

  const handleSelectionChange = (selectedItems) => {
    if (!onChange) return;
    const selectedIds = (selectedItems || [])
      .map((item) => {
        const optionValue = item.value;
        return typeof optionValue === "number"
          ? optionValue
          : parseInt(optionValue, 10);
      })
      .filter((id) => Number.isInteger(id) && id > 0);
    onChange(selectedIds);
  };

  return (
    <div className={`multi-select-dropdown-wrapper ${className}`}>
      <Select
        isMulti
        options={safeOptions}
        value={selectedOptions}
        onChange={handleSelectionChange}
        placeholder={placeholder}
        disabled={disabled}
        isSearchable={searchable}
        className="multi-select-dropdown"
        classNamePrefix="multi-select"
        noOptionsMessage={() => "No options available"}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </div>
  );
}

export default MultiSelectDropdown;
